<template>
	<headerSearch></headerSearch>
	<div class="w1440 personal_center">
		<div class="flex-box col90 ptb10 page_location">
			当前位置：
			<router-link class="col04" to="/BaseInfo">
				用户中心
				<span class="plr5">/</span>
			</router-link>
			<router-link class="col04" to="/BaseInfo">
				我的账户
				<span class="plr5">/</span>
			</router-link>
			<div class="now_page">基本信息</div>
		</div>
		<div class="flex-box flex-col-start">
			<personal-nav :firstIndex="0" :secondIndex="0"></personal-nav>
			<div class="ml10 flex-grow-1 part_r">
				<div class="flex-box point_account flex-between">
					<div class="item flex-box flex-center point cursor" @click="toIncomeDetail">
						<div>
							<div class="points">{{ userinfo.institution.score }}</div>
							<div class="fs16 col27">积分收益</div>
						</div>
					</div>
					<div class="item account fs16">
						<div class="flex-box account1 ml45 mr45">
							<div class="col90">机构联系人：</div>
							<div v-if="!showNameInput" class="col04">{{ name }}</div>
							<input v-else type="text" ref="nameInput" v-model="name" @blur="sureName" />
							<i class="edit" @click="showInput" v-if="!showNameInput"></i>
						</div>
						<div class="flex-box account2 ml45 mr45">
							<div class="col90">
								登录账号：
								<span class="col04">{{ userinfo.mobile }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="info_box">
					<div class="border" :class="licenseEdit?'on':''">
						<div class="fs18 col04 mb25 flex-box">
							<div class="flex-grow-1">营业执照</div>
							<div class="btn2 colf fs14" v-if="licenseEdit" @click="onSubmit">确认提交</div>
							<div class="fs14 colf save" :class="licenseEdit ? 'cancel' : ''" @click="licenseEdit = !licenseEdit">{{ licenseEdit ? "取消编辑" : "编辑" }}</div>
						</div>
						<div class="flex-box flex-col-start flex-between mb20">
							<div>
								<div class="up_box fs22 mb20">
									<upLoad @upSuc="saveImage" :disabled="!licenseEdit">
										<div :class="licenseEdit ? 're_up' : ''" v-if="imageUrl">
											<img :src="auth.content.license_image ? auth.content.license_image : imageUrl" alt="" class="up_img" />
											<div v-if="institutionAuth.license_image_auth" class="wait_audit flex-box flex-center"></div>
										</div>
										<template v-else>
											<div class="plus col12 flex-box flex-center">上传图片</div>
										</template>
									</upLoad>
								</div>
								<div class="fs14 col90">执照编号：{{ userinfo.institution.license_no }}</div>
								<div class="limit fs14">
									有限期至：
									<span class="fwb">{{ userinfo.institution.expire_end }}</span>
								</div>
							</div>
						</div>
						<!-- <div class="red fs14 mb45">拒绝理由：123123123123</div> -->
					</div>
					<div class="border" :class="medicalEdit?'on':''">
						<div class="fs18 col04 mb25 flex-box">
							<div class="flex-grow-1">医疗经营执照</div>
							<div class="btn2 colf fs14" v-if="medicalEdit" @click="onSubmit">确认提交</div>
							<div class="fs14 colf save" :class="medicalEdit ? 'cancel' : ''" @click="medicalEdit = !medicalEdit">{{ medicalEdit ? "取消编辑" : "编辑" }}</div>
						</div>
						<div class="flex-box flex-col-start flex-between mb20">
							<div>
								<div class="up_box fs22 mb20">
									<upLoad @upSuc="saveImage2" :disabled="!medicalEdit">
										<div :class="medicalEdit ? 're_up' : ''" v-if="imageUrl2">
											<img :src="auth.content.medical_license_image ? auth.content.medical_license_image : imageUrl2" alt="" class="up_img" />
											<div v-if="institutionAuth.medical_license_auth" class="wait_audit flex-box flex-center"></div>
										</div>
										<template v-else>
											<div class="plus col12 flex-box flex-center">上传图片</div>
										</template>
									</upLoad>
								</div>
								<div class="fs14 col90">执照编号：{{ userinfo.institution.medical_license_no }}</div>
								<div class="limit fs14">
									有限期至：
									<span class="fwb">{{ userinfo.institution.medical_expire_end }}</span>
								</div>
							</div>
						</div>
						<!-- <div class="red fs14 mb45">拒绝理由：123123123123</div> -->
					</div>
					<div class="border" :class="salesmanIdcardEdit?'on':''">
						<div class="fs18 col04 mb25 flex-box">
							<div class="flex-grow-1">委托人信息</div>
							<div class="btn2 colf fs14" v-if="salesmanIdcardEdit" @click="onSubmit()">确认提交</div>
							<div class="fs14 colf save" :class="salesmanIdcardEdit ? 'cancel' : ''" @click="salesmanIdcardEdit = !salesmanIdcardEdit">{{ salesmanIdcardEdit ? "取消编辑" : "编辑" }}</div>
						</div>
						<div class="flex-box flex-col-start flex-between">
							<div>
								<div class="fs16 col12 tc mb25">身份证正面</div>
								<div class="up_box fs22 mb20">
									<upLoad @upSuc="saveImage5" :disabled="!salesmanIdcardEdit">
										<div :class="salesmanIdcardEdit ? 're_up' : ''" v-if="imageUrl5 || auth.content.salesman_idcard_face">
											<img :src="auth.content.salesman_idcard_face ? auth.content.salesman_idcard_face : imageUrl5" alt="" class="up_img" />
											<div v-if="institutionAuth.salesman_identify_auth" class="wait_audit flex-box flex-center"></div>
										</div>
										<template v-else>
											<div class="plus col12 flex-box flex-center">上传图片</div>
										</template>
									</upLoad>
								</div>
							</div>
							<div>
								<div class="fs16 col12 tc mb25">身份证反面</div>
								<div class="up_box fs22 mb20">
									<upLoad @upSuc="saveImage6" :disabled="!salesmanIdcardEdit">
										<div :class="salesmanIdcardEdit ? 're_up' : ''" v-if="imageUrl6 || auth.content.salesman_idcard_back">
											<img :src="auth.content.salesman_idcard_back ? auth.content.salesman_idcard_back : imageUrl6" alt="" class="up_img" />
											<div v-if="institutionAuth.salesman_identify_auth" class="wait_audit flex-box flex-center"></div>
										</div>
										<template v-else>
											<div class="plus col12 flex-box flex-center">上传图片</div>
										</template>
									</upLoad>
								</div>
							</div>
						</div>
						<div class="flex-box flex-col-start flex-between">
							<div>
								<div class="fs16 col12 tc mb25">法人委托书</div>
								<div class="up_box fs22 mb20">
									<upLoad @upSuc="saveImage7" :disabled="!salesmanIdcardEdit">
										<div :class="salesmanIdcardEdit ? 're_up' : ''" v-if="imageUrl7 || auth.content.legal_authorization_image">
											<img :src="auth.content.legal_authorization_image ? auth.content.legal_authorization_image : imageUrl7" alt="" class="up_img" />
											<div v-if="institutionAuth.salesman_identify_auth" class="wait_audit flex-box flex-center"></div>
										</div>
										<template v-else>
											<div class="plus col12 flex-box flex-center">上传图片</div>
										</template>
									</upLoad>
								</div>
							</div>
						</div>
						<!-- <div class="red fs14 mb45">拒绝理由：123123123123</div> -->
					</div>
					<div class="border" :class="idcardEdit?'on':''">
						<div class="fs18 col04 mb25 flex-box">
							<div class="flex-grow-1">法人身份证</div>
							<div class="btn2 colf fs14" v-if="idcardEdit" @click="onSubmit()">确认提交</div>
							<div class="fs14 colf save" :class="idcardEdit ? 'cancel' : ''" @click="idcardEdit = !idcardEdit">{{ idcardEdit ? "取消编辑" : "编辑" }}</div>
						</div>
						<div class="flex-box flex-col-start flex-between">
							<div>
								<div class="fs16 col12 tc mb25">正面</div>
								<div class="up_box fs22 mb20">
									<upLoad @upSuc="saveImage3" :disabled="!idcardEdit">
										<div :class="idcardEdit ? 're_up' : ''" v-if="imageUrl3">
											<img :src="auth.content.idcard_face ? auth.content.idcard_face : imageUrl3" alt="" class="up_img" />
											<div v-if="institutionAuth.identify_auth" class="wait_audit flex-box flex-center"></div>
										</div>
										<template v-else>
											<div class="plus col12 flex-box flex-center">上传图片</div>
										</template>
									</upLoad>
								</div>
							</div>
							<div>
								<div class="fs16 col12 tc mb25">反面</div>
								<div class="up_box fs22 mb20">
									<upLoad @upSuc="saveImage4" :disabled="!idcardEdit">
										<div :class="idcardEdit ? 're_up' : ''" v-if="imageUrl4">
											<img :src="auth.content.idcard_back ? auth.content.idcard_back : imageUrl4" alt="" class="up_img" />
											<div v-if="institutionAuth.identify_auth" class="wait_audit flex-box flex-center"></div>
										</div>
										<template v-else>
											<div class="plus col12 flex-box flex-center">上传图片</div>
										</template>
									</upLoad>
								</div>
							</div>
						</div>
						<div class="fs14 col90">身份证号：{{ userinfo.institution.legal_no }}</div>
						<div class="limit fs14 mb20">
							有效期：
							<span class="fwb">{{ userinfo.institution.idcard_start }} - {{ userinfo.institution.idcard_end }}</span>
						</div>
						<!-- <div class="red fs14 mb45">拒绝理由：123123123123</div> -->
					</div>
					<div class="border" :class="otherEdit?'on':''">
						<div class="fs18 col04 mb25 flex-box">
							<div class="flex-grow-1">其他资质补充</div>
							<div class="btn2 colf fs14" v-if="otherEdit" @click="onotherSubmit">确认提交</div>
							<div class="fs14 colf save" :class="otherEdit ? 'cancel' : ''" @click="onOtherEdit()">{{ otherEdit ? "取消编辑" : "编辑" }}</div>
						</div>
						<div class="flex-box flex-col-start flex-between flex-wrap">
							<div class="other_box" v-for="(other, index) in others" :key="index">
								<div class="fs16 col12 tc mb25 flex-box flex-between choose cursor" @click="otherChecked(index)" :class="other.checked ? 'on' : ''">{{ other.title }}</div>
								<template v-if="other.checked">
									<div class="up_box fs22 mb20">
										<upLoad @upSuc="saveOtherImage($event, index)" :disabled="!other.checked">
											<div :class="other.checked ? 're_up' : ''" v-if="other.image">
												<img :src="other.image" alt="" class="up_img" />
												<div v-if="institutionAuth.other_auth" class="wait_audit flex-box flex-center"></div>
											</div>
											<template v-else>
												<div class="plus col12 flex-box flex-center">上传图片</div>
											</template>
										</upLoad>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PersonalNav from "../../../components/PersonalNav.vue";
	import upLoad from "@/components/Upload.vue";
	import { useHead } from "@unhead/vue";
	import { onMounted } from "vue";
	export default {
		setup() {
			onMounted(() => {
				useHead({
					title: "基本信息-小狮优选",
					meta: [
						{ name: "description", content: "This is my page description" },
						{ property: "og:title", content: "My Page Title" },
						{ property: "og:description", content: "This is my page description" },
						{ property: "og:url", content: "https://example.com/my-page" },
						{ property: "og:image", content: "https://example.com/my-image.jpg" },
					],
					link: [{ rel: "canonical", href: "https://example.com/my-page" }],
				});
			});
		},
		components: {
			PersonalNav,
			upLoad,
		},
		data() {
			return {
				showNameInput: false,
				name: "",
				certEdit: false,
				licenseEdit: false,
				medicalEdit: false,
				idcardEdit: false,
				salesmanIdcardEdit: false,
				otherEdit: false,
				selectedFile: true,
				uploadStatus: null,
				userinfo: {
					mobile: "",
					institution: {
						avatar: "",
						company_name: "",
						contact: "",
						license_image: "",
						license_no: "",
						expire_end: "",
						score: 0,
						institution_type: 0,
					},
				},
				institutionAuth: {
					license_image_auth: {
						content: {
							license_image: "",
						},
					},
					medical_license_auth: {
						content: {
							medical_license_image: "",
						},
					},
					identify_auth: {
						content: {
							idcard_face: "",
							idcard_back: "",
						},
					},
					salesman_identify_auth: {
						content: {
							salesman_idcard_face: "",
							salesman_idcard_back: "",
							salesman_legal_authorization_image: "",
						},
					},
				},
				auth: {
					change_type: 0,
					content: {},
				},
				others: [
					{ title: "全麻资质", image: "", checked: false },
					{ title: "麻醉药品购用印签卡", image: "", checked: false },
					{ title: "第一类精神药品购用印签卡", image: "", checked: false },
				],
				otherInit: 0,
			};
		},
		computed: {
			//营业执照
			imageUrl() {
				return !this.institutionAuth.license_image_auth ? this.userinfo.institution.license_image : this.institutionAuth.license_image_auth.content.license_image;
			},
			//医疗经营执照
			imageUrl2() {
				return !this.institutionAuth.medical_license_auth ? this.userinfo.institution.medical_license_image : this.institutionAuth.medical_license_auth.content.medical_license_image;
			},
			//身份证正面
			imageUrl3() {
				return !this.institutionAuth.identify_auth ? this.userinfo.institution.idcard_face : this.institutionAuth.identify_auth.content.idcard_face;
			},
			//身份证反面
			imageUrl4() {
				return !this.institutionAuth.identify_auth ? this.userinfo.institution.idcard_back : this.institutionAuth.identify_auth.content.idcard_back;
			},
			//委托人身份证正面
			imageUrl5() {
				return !this.institutionAuth.salesman_identify_auth ? this.userinfo.institution.salesman_idcard_face : this.institutionAuth.salesman_identify_auth.content.salesman_idcard_face;
			},
			//委托人身份证反面
			imageUrl6() {
				return !this.institutionAuth.salesman_identify_auth ? this.userinfo.institution.salesman_idcard_back : this.institutionAuth.salesman_identify_auth.content.salesman_idcard_back;
			},
			//委托人身份证反面
			imageUrl7() {
				return !this.institutionAuth.salesman_identify_auth ? this.userinfo.institution.legal_authorization_image : this.institutionAuth.salesman_identify_auth.content.legal_authorization_image;
			},
			islogin() {
				return this.$h.islogin();
			},
		},
		created() {
			if (!this.islogin) {
				this.$router.push("/Login");
			} else {
				this.getUserInfo();
			}
		},
		methods: {
			// 点击跳转积分明细
			toIncomeDetail() {
				this.$router.push("/IncomeDetail");
			},
			saveImage(e) {
				this.auth = {
					change_type: 1,
					content: {
						license_image: e,
					},
				};
				// this.onSubmit(data)
				this.shibie("license_image", e);
			},
			saveImage2(e) {
				this.auth = {
					change_type: 2,
					content: {
						medical_license_image: e,
					},
				};
				this.shibie("medical_license_image", e);
			},
			saveImage3(e) {
				this.auth.change_type = 3;
				this.auth.content.idcard_face = e;
				this.shibie("idcard_face", e);
			},
			saveImage4(e) {
				this.auth.change_type = 3;
				this.auth.content.idcard_back = e;
				this.institutionAuth = this.auth;
				this.shibie("idcard_back", e);
			},
			//委托人
			saveImage5(e) {
				this.auth.change_type = 5;
				this.auth.content.salesman_idcard_face = e;
				console.log(e);
			},
			saveImage6(e) {
				this.auth.change_type = 5;
				this.auth.content.salesman_idcard_back = e;
			},
			saveImage7(e) {
				this.auth.change_type = 5;
				this.auth.content.legal_authorization_image = e;
			},
			onOtherEdit() {
				this.otherEdit = !this.otherEdit;
				if (!this.otherEdit) {
					let others = [];
					this.others.forEach((item) => {
						if (!item.image) {
							item.checked = false;
						}
						others.push(item);
					});
					this.others = others;
				}
			},
			otherChecked(index) {
				if (!this.otherEdit) {
					return;
				}
				this.others[index].checked = !this.others[index].checked;
			},
			saveOtherImage(e, index) {
				this.others[index].image = e;
			},

			shibie(type, img) {
				let data = {
					type: type,
					img: img,
				};
				if (type == "idcard_face" || type == "idcard_back") {
					this.$api.IdcardSpot(data).then((ret) => {
						if (type == "idcard_face") {
							this.auth.content.legal_no = ret.data.legal_no;
							this.auth.content.legal_person = ret.data.legal_person;
						} else if (type == "idcard_back") {
							this.auth.content.idcard_end = ret.data.idcard_end;
							this.auth.content.idcard_start = ret.data.idcard_start;
						}
						//this.onSubmit()
					});
				} else if (type == "license_image") {
					this.$api.LicenseSpot(data).then((ret) => {
						this.auth.content.license_no = ret.data.tax_no;
						this.auth.content.tax_no = ret.data.tax_no;
						this.auth.content.expire_start = ret.data.expire_start;
						this.auth.content.expire_end = ret.data.expire_end;
						//this.onSubmit()
					});
				} else {
					//this.onSubmit()
				}
			},
			onotherSubmit() {
				this.auth.change_type = 4;
				let others = [];
				this.others.forEach((item) => {
					if (!item.checked) {
						item.image = "";
					}
					others.push(item);
				});
				this.auth.content = others;
				this.onSubmit();
			},
			//提交审核
			onSubmit() {
				let that = this;
				let data = this.auth;
				this.$api
					.SaveIns(data)
					.then((res) => {
						(this.licenseEdit = false), (this.medicalEdit = false), (this.idcardEdit = false);
						this.salesmanIdcardEdit = false;
						this.otherEdit = false;
						this.$message({
							customClass: "custom-message",
							message: res.msg,
							type: "success",
						});
						this.getUserInfo();
					})
					.catch((err) => {
						this.$alert(err.msg);
					});
			},
			// 获取用户信息
			getUserInfo() {
				let that = this;
				that.$api.GetUserInfo().then((res) => {
					if (res.code == 1) {
						that.userinfo = res.data;
						that.name = that.userinfo.institution.contact;
					}
					that.otherInit += 1;
					that.otherCert();
				});
				that.$api.MyInstitution().then((res) => {
					if (res.code == 1) {
						that.institutionAuth = res.data.auth;
					}
					that.otherInit += 1;
					that.otherCert();
				});
			},
			//其他资质
			otherCert() {
				if (this.otherInit != 2) {
					return;
				}
				let others = this.others;
				let institutionOther = this.userinfo.institution.others;
				let otherAuth = this.institutionAuth.other_auth ? this.institutionAuth.other_auth.content : null;
				for (let i = 0; i < others.length; i++) {
					if (otherAuth) {
						for (let k = 0; k < otherAuth.length; k++) {
							if (others[i].title === otherAuth[k].title && otherAuth[k].image) {
								others[i].image = otherAuth[k].image;
								others[i].checked = true;
							}
						}
					} else if (institutionOther) {
						for (let k = 0; k < institutionOther.length; k++) {
							if (others[i].title === institutionOther[k].title && institutionOther[k].image) {
								others[i].image = institutionOther[k].image;
								others[i].checked = true;
							}
						}
					}
				}
				this.others = others;
			},
			showInput() {
				this.showNameInput = !this.showNameInput;
			},
			//保存姓名
			sureName() {
				this.showNameInput = !this.showNameInput;
				let contact = this.name;
				if (contact.trim() == "") {
					uni.showToast({
						title: "联系人不得为空",
						icon: "none",
					});
					return;
				}
				this.$api
					.SaveContact({
						contact: contact,
					})
					.then((res) => {});
			},
			onFileChange(event) {
				const file = event.target.files[0];
				if (file && file.type.startsWith("image/")) {
					this.selectedFile = file;
					const reader = new FileReader();
					reader.onload = (e) => {
						this.imageUrl = e.target.result;
					};
					reader.readAsDataURL(file);
					this.uploadImage("license_image");
				} else {
					alert("请上传有效的图片文件");
				}
			},
			async uploadImage(field) {
				if (!this.selectedFile) return;

				const formData = new FormData();
				formData.append("file", this.selectedFile);

				try {
					// 替换为你的上传接口 URL
					const response = await axios.post("https://your-api-endpoint/upload", formData, {
						headers: {
							"Content-Type": "multipart/form-data",
						},
					});

					if (response.status === 200) {
						this.uploadStatus = "success";
					} else {
						this.uploadStatus = "error";
					}
				} catch (error) {
					console.error("上传失败:", error);
					this.uploadStatus = "error";
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.part_r {
		.point_account {
			.item {
				flex: 1;
				height: 140px;
				background: #ffffff;

				&:nth-of-type(1) {
					margin-right: 5px;
				}

				&:nth-of-type(2) {
					margin-left: 5px;
				}
			}

			.point::before {
				width: 80px;
				height: 80px;
				display: block;
				content: "";
				background: url("/src/assets/static/icon/c_point.png") no-repeat center;
				background-size: 100%;
				margin-right: 40px;
			}

			.points {
				font-size: 32px;
				font-weight: 600;
				color: #1275ff;
			}

			.account {
				padding: 20px 0 0;
			}

			.account1 {
				margin-bottom: 12px;
				height: 50px;

				.edit {
					width: 18px;
					height: 20px;
					display: block;
					background: url("/src/assets/static/icon/c_edit.png") no-repeat center;
					background-size: 100%;
					margin-left: 14px;
					cursor: pointer;
				}

				input {
					flex: 1;
					border-bottom: 0.6px solid rgba(98, 134, 171, 0.4);
				}
			}

			.account1::before {
				display: block;
				content: "";
				width: 18px;
				height: 20px;
				background: url("/src/assets/static/icon/c_info1.png") no-repeat center;
				background-size: 100%;
				margin-right: 14px;
			}

			.account2::before {
				display: block;
				content: "";
				width: 18px;
				height: 20px;
				background: url("/src/assets/static/icon/c_info2.png") no-repeat center;
				background-size: 16.5px 20px;
				margin-right: 14px;
			}
		}

		.info_box {
			width: 100%;
			margin-top: 10px;
			background: #ffffff;
			padding: 0 0 90px;

      .border{
        padding: 20px 44px;
        &.on{
          background: #e7f1ff;
        }
      }

			.up_box {
				border: 4px solid #e7f1ff;
				width: 484px;
				height: 318px;
				border-radius: 10px;
				position: relative;
				overflow: hidden;

				.up_img {
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 1;
					object-fit: cover;
				}

				.up_input {
					width: 100%;
					height: 100%;
					opacity: 0;
					position: absolute;
					top: 0;
					left: 0;
					cursor: pointer;
					z-index: 4;
				}
			}

			.plus {
				width: 476px;
				height: 310px;
			}

			.re_up {
				&::before,
				&::after {
					display: none;
				}

				&:hover::before {
					content: "重新上传";
					color: #fff;
					background: url("/src/assets/static/icon/c_reup.png") no-repeat calc(50% - 50px) center;
					background-size: 20px 22.5px;
					margin-right: 8px;
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 10;
					padding-left: 30px;
					display: flex;
					align-items: center;
					justify-content: center;
				}

				&:hover::after {
					content: "";
					display: block;
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 9;
					background: rgba(86, 86, 86, 0.4);
				}

				&:hover .wait_audit {
					display: none;
				}
			}

			.wait_audit {
				border-radius: 10px;
				width: 100%;
				height: 100%;
				background: rgba(86, 86, 86, 0.4);
				z-index: 2;
				position: absolute;
				left: 0px;
				top: 0px;
				bottom: 0;
				right: 0;
				color: #fff;

				&::before {
					display: block;
					content: "";
					width: 163.5px;
					height: 124px;
					background: url("/src/assets/static/icon/c_waitaudit.png") no-repeat center;
					background-size: 100%;
				}
			}
		}

		.limit {
			height: 44px;
			width: 100%;
			line-height: 44px;
			padding-left: 20px;
			color: #70a0fe;
			background: rgba(215, 229, 255, 0.2);
			border-radius: 4px;
			margin-top: 14px;

			span {
				color: #70a0fe;
			}
		}

		.wait {
			color: #eb3f25;
			margin-top: 24px;

			&::before {
				content: "";
				display: block;
				background: url("/src/assets/static/icon/c_wait.png") no-repeat center;
				background-size: 100%;
				width: 20px;
				height: 20px;
				margin-right: 10px;
			}
		}
	}

	.save,
	.btn2 {
		line-height: 40px;
		padding: 0 20px;
		background: #1275ff;
		border-radius: 5px;
		margin: 0 10px;
		cursor: pointer;

		&.cancel {
			line-height: 38px;
			padding: 0 20px;
			border-radius: 5px;
			margin: 0 10px;
			border: 1px solid #1275ff;
			color: #1275ff;
			background: #fff;
		}
	}

	.btn1 {
		line-height: 40px;
		padding: 0 20px;
		border-radius: 5px;
		margin: 0 10px;
		border: 1px solid #1275ff;
		color: #1275ff;
	}

	.choose::after {
		width: 20px;
		height: 20px;
		display: block;
		content: "";
		background: url("/src/assets/static/icon/c_check2.png") no-repeat center;
		background-size: 20px 20px;
		border-radius: 50%;
		margin-right: 10px;
	}

	.choose.on::after {
		background-image: url("/src/assets/static/icon/c_check2-on.png");
	}

	.other_box {
		width: 484px;
	}
</style>
